import { Col, Row } from 'antd'
import GauTalking from 'components/GauTalking'
import React from 'react'

export default function GauLeft({ children, messages, onDoneTalking }) {
    return <Row gutter={50}>
        <Col span={8}>
            <GauTalking messages={messages} onDone={onDoneTalking} />
        </Col>
        <Col span={16}>
            { children }
        </Col>
    </Row>
}
